import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { DemandasMonitoramentoService } from '../../services/demandas-monitoramento.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { NavigationService } from '../../services/navigation.service';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-demandas-monitoramento-mensagens-edit',
  templateUrl: './detalhe-demandas-monitoramento-mensagens-edit.component.html',
  styleUrls: ['./detalhe-demandas-monitoramento-mensagens-edit.component.scss']
})
export class DetalheDemandasMonitoramentoMensagensEditComponent extends BaseFormComponent<any> implements OnInit {

  idProjeto: number;
  infoDemanda: any;
  infoProjeto: ProjetoCadastro;
  serverUrl: string = environment.serverUrl;
  link: string;
  linkLabel: string;

  constructor(
    private myService: DemandasMonitoramentoService,
    private toastr: ToastrService,
    public activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.loading();
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      
      this.infoDemanda = this.activatedRoute.snapshot.data['infoDemanda'];
      this.initForm();
      this.loaded();
    });
  }

  initForm() {
    this.form = this.fb.group({
      message: ['', Validators.required],
    });
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();

      this.addSub(
        this.myService.createMessage(this.infoDemanda.id, this.form.value).subscribe({
          next: (res) => {
            window.location.reload();
            this.toastr.info('Mensagem salva com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.toastr.error('Erro ao salvar: ' + error.error);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
    }
  }

  voltar() {
    this.navigation.back();
  }

  cadastro() {
    return ['/projetos', 'projeto', this.idProjeto, 'demandas', this.infoDemanda.id];
  }
  
  concluir() {
    if (this.form.valid) {
      this.loading();

      this.addSub(
        this.myService.concluir(this.infoDemanda.id, this.form.value).subscribe({
          next: (res) => {
            window.location.reload();
            this.toastr.info('Demanda concluída com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.toastr.error('Erro ao salvar: ' + error.error.message);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
    }
  }
  transferir() {
    if (this.form.valid) {
      this.loading();

      this.addSub(
        this.myService.transferir(this.infoDemanda.id, this.form.value).subscribe({
          next: (res) => {
            window.location.reload();
            this.toastr.info('Demanda transferida com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.toastr.error('Erro ao salvar: ' + error.error.message);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
    }
  }

}
